import type {Form} from 'src/typings';
import {ngAsync} from '../utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class FormDataService {
    public static readonly serviceName: string = 'formDataService';

    public static readonly FORMS_ROUTE: string = 'forms'

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getForms(params: any): Promise<Form[]> {
        return this.ajaxService
            .createRequest(FormDataService.FORMS_ROUTE)
            .get(params);
    }
}